/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router"

import { Route as rootRouteImport } from "./routes/__root"
import { Route as authIndexRouteImport } from "./routes/(auth)/index"
import { Route as authlessInviteRouteImport } from "./routes/(authless)/invite"
import { Route as authHeadedRouteRouteImport } from "./routes/(auth)/_headed/route"
import { Route as authlessSignupIndexRouteImport } from "./routes/(authless)/signup/index"
import { Route as authlessLoginIndexRouteImport } from "./routes/(authless)/login/index"
import { Route as authlessSignupDistributorRouteImport } from "./routes/(authless)/signup/distributor"
import { Route as authlessLoginDistributorRouteImport } from "./routes/(authless)/login/distributor"
import { Route as authHeadedHomeRouteImport } from "./routes/(auth)/_headed/home"
import { Route as authheadlessWelcomeRouteImport } from "./routes/(auth)/(headless)/welcome"
import { Route as authHeadedAccountRouteRouteImport } from "./routes/(auth)/_headed/account/route"
import { Route as authheadlessReportsRouteRouteImport } from "./routes/(auth)/(headless)/reports/route"
import { Route as authHeadedResourcesIndexRouteImport } from "./routes/(auth)/_headed/resources/index"
import { Route as authHeadedReportsIndexRouteImport } from "./routes/(auth)/_headed/reports/index"
import { Route as authHeadedResourcesLayoutRouteImport } from "./routes/(auth)/_headed/resources/_layout"
import { Route as authHeadedReportsLayoutRouteImport } from "./routes/(auth)/_headed/reports/_layout"
import { Route as authHeadedInsightsLayoutRouteImport } from "./routes/(auth)/_headed/insights/_layout"
import { Route as authHeadedFundsLayoutRouteImport } from "./routes/(auth)/_headed/funds/_layout"
import { Route as authHeadedFundsFund_idRouteImport } from "./routes/(auth)/_headed/funds/$fund_id"
import { Route as authHeadedClientsLayoutRouteImport } from "./routes/(auth)/_headed/clients/_layout"
import { Route as authHeadedClientsIdRouteImport } from "./routes/(auth)/_headed/clients/$id"
import { Route as authHeadedAccountTeamMembersRouteImport } from "./routes/(auth)/_headed/account/team-members"
import { Route as authHeadedAccountSettingRouteImport } from "./routes/(auth)/_headed/account/setting"
import { Route as authHeadedAccountBrandingRouteImport } from "./routes/(auth)/_headed/account/branding"
import { Route as authheadlessMfdHandleRouteImport } from "./routes/(auth)/(headless)/mfd.$handle"
import { Route as authheadlessdistributorSetPasswordRouteImport } from "./routes/(auth)/(headless)/(distributor)/set-password"
import { Route as authheadlessdistributorResetPasswordRouteImport } from "./routes/(auth)/(headless)/(distributor)/reset-password"
import { Route as authHeadedInsightsLayoutIndexRouteImport } from "./routes/(auth)/_headed/insights/_layout.index"
import { Route as authHeadedFundsLayoutIndexRouteImport } from "./routes/(auth)/_headed/funds/_layout.index"
import { Route as authHeadedClientsLayoutIndexRouteImport } from "./routes/(auth)/_headed/clients/_layout.index"
import { Route as authHeadedClientsIdIndexRouteImport } from "./routes/(auth)/_headed/clients/$id/index"
import { Route as authHeadedResourcesLayoutWebinarsRouteImport } from "./routes/(auth)/_headed/resources/_layout.webinars"
import { Route as authHeadedResourcesLayoutMarketingRouteImport } from "./routes/(auth)/_headed/resources/_layout.marketing"
import { Route as authHeadedResourcesLayoutKnowledgeRouteImport } from "./routes/(auth)/_headed/resources/_layout.knowledge"
import { Route as authHeadedResourcesLayoutFeaturedRouteImport } from "./routes/(auth)/_headed/resources/_layout.featured"
import { Route as authHeadedReportsLayoutChangeOfBrokerRouteImport } from "./routes/(auth)/_headed/reports/_layout.change-of-broker"
import { Route as authHeadedReportsLayoutBrokerageRouteImport } from "./routes/(auth)/_headed/reports/_layout.brokerage"
import { Route as authHeadedInsightsLayoutSipRouteImport } from "./routes/(auth)/_headed/insights/_layout.sip"
import { Route as authHeadedInsightsLayoutClientsRouteImport } from "./routes/(auth)/_headed/insights/_layout.clients"
import { Route as authHeadedInsightsLayoutAumRouteImport } from "./routes/(auth)/_headed/insights/_layout.aum"
import { Route as authHeadedFundsBasketBasket_idRouteImport } from "./routes/(auth)/_headed/funds/basket.$basket_id"
import { Route as authHeadedFundsLayoutNfoRouteImport } from "./routes/(auth)/_headed/funds/_layout.nfo"
import { Route as authHeadedFundsLayoutCompareRouteImport } from "./routes/(auth)/_headed/funds/_layout.compare"
import { Route as authHeadedFundsLayoutBasketRouteImport } from "./routes/(auth)/_headed/funds/_layout.basket"
import { Route as authHeadedClientsFamiliesIdRouteImport } from "./routes/(auth)/_headed/clients/families.$id"
import { Route as authHeadedClientsLayoutFamiliesRouteImport } from "./routes/(auth)/_headed/clients/_layout.families"
import { Route as authHeadedClientsIdReviewRouteImport } from "./routes/(auth)/_headed/clients/$id/review"
import { Route as authHeadedClientsIdPortfolioRouteImport } from "./routes/(auth)/_headed/clients/$id/portfolio"
import { Route as authHeadedClientsIdPlanningRouteImport } from "./routes/(auth)/_headed/clients/$id/planning"
import { Route as authHeadedClientsIdAccountRouteImport } from "./routes/(auth)/_headed/clients/$id/account"
import { Route as authheadlessReportsFundsCompareRouteImport } from "./routes/(auth)/(headless)/reports/funds/compare"
import { Route as authheadlessMfdDeclarationHandleRouteImport } from "./routes/(auth)/(headless)/mfd.declaration.$handle"
import { Route as authHeadedFundsBasketBasket_idIndexRouteImport } from "./routes/(auth)/_headed/funds/basket.$basket_id/index"
import { Route as authHeadedFundsBasketBasket_idLinkedSipRouteImport } from "./routes/(auth)/_headed/funds/basket.$basket_id/linked-sip"
import { Route as authHeadedClientsIdReviewReviewIdRouteImport } from "./routes/(auth)/_headed/clients/$id_.review.$reviewId"
import { Route as authheadlessReportsFamiliesIdPortfolioRouteImport } from "./routes/(auth)/(headless)/reports/families/$id.portfolio"
import { Route as authheadlessReportsClientsIdPortfolioRouteImport } from "./routes/(auth)/(headless)/reports/clients/$id.portfolio"
import { Route as authheadlessReportsClientsIdOrderHistoryRouteImport } from "./routes/(auth)/(headless)/reports/clients/$id.order-history"
import { Route as authheadlessReportsClientsIdCobRouteImport } from "./routes/(auth)/(headless)/reports/clients/$id.cob"
import { Route as authheadlessReportsClientsIdCapitalGainsRouteImport } from "./routes/(auth)/(headless)/reports/clients/$id.capital-gains"
import { Route as authheadlessReportsClientsIdProposalProposalIdRouteImport } from "./routes/(auth)/(headless)/reports/clients/$id.proposal.$proposalId"

const authRouteImport = createFileRoute("/(auth)")()
const authHeadedResourcesRouteImport = createFileRoute(
  "/(auth)/_headed/resources",
)()
const authHeadedReportsRouteImport = createFileRoute(
  "/(auth)/_headed/reports",
)()
const authHeadedInsightsRouteImport = createFileRoute(
  "/(auth)/_headed/insights",
)()
const authHeadedFundsRouteImport = createFileRoute("/(auth)/_headed/funds")()
const authHeadedClientsRouteImport = createFileRoute(
  "/(auth)/_headed/clients",
)()

const authRoute = authRouteImport.update({
  id: "/(auth)",
  getParentRoute: () => rootRouteImport,
} as any)
const authIndexRoute = authIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => authRoute,
} as any)
const authlessInviteRoute = authlessInviteRouteImport.update({
  id: "/(authless)/invite",
  path: "/invite",
  getParentRoute: () => rootRouteImport,
} as any)
const authHeadedRouteRoute = authHeadedRouteRouteImport.update({
  id: "/_headed",
  getParentRoute: () => authRoute,
} as any)
const authHeadedResourcesRoute = authHeadedResourcesRouteImport.update({
  id: "/resources",
  path: "/resources",
  getParentRoute: () => authHeadedRouteRoute,
} as any)
const authHeadedReportsRoute = authHeadedReportsRouteImport.update({
  id: "/reports",
  path: "/reports",
  getParentRoute: () => authHeadedRouteRoute,
} as any)
const authHeadedInsightsRoute = authHeadedInsightsRouteImport.update({
  id: "/insights",
  path: "/insights",
  getParentRoute: () => authHeadedRouteRoute,
} as any)
const authHeadedFundsRoute = authHeadedFundsRouteImport.update({
  id: "/funds",
  path: "/funds",
  getParentRoute: () => authHeadedRouteRoute,
} as any)
const authHeadedClientsRoute = authHeadedClientsRouteImport.update({
  id: "/clients",
  path: "/clients",
  getParentRoute: () => authHeadedRouteRoute,
} as any)
const authlessSignupIndexRoute = authlessSignupIndexRouteImport.update({
  id: "/(authless)/signup/",
  path: "/signup/",
  getParentRoute: () => rootRouteImport,
} as any)
const authlessLoginIndexRoute = authlessLoginIndexRouteImport.update({
  id: "/(authless)/login/",
  path: "/login/",
  getParentRoute: () => rootRouteImport,
} as any)
const authlessSignupDistributorRoute =
  authlessSignupDistributorRouteImport.update({
    id: "/(authless)/signup/distributor",
    path: "/signup/distributor",
    getParentRoute: () => rootRouteImport,
  } as any)
const authlessLoginDistributorRoute =
  authlessLoginDistributorRouteImport.update({
    id: "/(authless)/login/distributor",
    path: "/login/distributor",
    getParentRoute: () => rootRouteImport,
  } as any)
const authHeadedHomeRoute = authHeadedHomeRouteImport.update({
  id: "/home",
  path: "/home",
  getParentRoute: () => authHeadedRouteRoute,
} as any)
const authheadlessWelcomeRoute = authheadlessWelcomeRouteImport.update({
  id: "/(headless)/welcome",
  path: "/welcome",
  getParentRoute: () => authRoute,
} as any)
const authHeadedAccountRouteRoute = authHeadedAccountRouteRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => authHeadedRouteRoute,
} as any)
const authheadlessReportsRouteRoute =
  authheadlessReportsRouteRouteImport.update({
    id: "/(headless)/reports",
    path: "/reports",
    getParentRoute: () => authRoute,
  } as any)
const authHeadedResourcesIndexRoute =
  authHeadedResourcesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => authHeadedResourcesRoute,
  } as any)
const authHeadedReportsIndexRoute = authHeadedReportsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => authHeadedReportsRoute,
} as any)
const authHeadedResourcesLayoutRoute =
  authHeadedResourcesLayoutRouteImport.update({
    id: "/_layout",
    getParentRoute: () => authHeadedResourcesRoute,
  } as any)
const authHeadedReportsLayoutRoute = authHeadedReportsLayoutRouteImport.update({
  id: "/_layout",
  getParentRoute: () => authHeadedReportsRoute,
} as any)
const authHeadedInsightsLayoutRoute =
  authHeadedInsightsLayoutRouteImport.update({
    id: "/_layout",
    getParentRoute: () => authHeadedInsightsRoute,
  } as any)
const authHeadedFundsLayoutRoute = authHeadedFundsLayoutRouteImport.update({
  id: "/_layout",
  getParentRoute: () => authHeadedFundsRoute,
} as any)
const authHeadedFundsFund_idRoute = authHeadedFundsFund_idRouteImport.update({
  id: "/funds/$fund_id",
  path: "/funds/$fund_id",
  getParentRoute: () => authHeadedRouteRoute,
} as any)
const authHeadedClientsLayoutRoute = authHeadedClientsLayoutRouteImport.update({
  id: "/_layout",
  getParentRoute: () => authHeadedClientsRoute,
} as any)
const authHeadedClientsIdRoute = authHeadedClientsIdRouteImport.update({
  id: "/clients/$id",
  path: "/clients/$id",
  getParentRoute: () => authHeadedRouteRoute,
} as any)
const authHeadedAccountTeamMembersRoute =
  authHeadedAccountTeamMembersRouteImport.update({
    id: "/team-members",
    path: "/team-members",
    getParentRoute: () => authHeadedAccountRouteRoute,
  } as any)
const authHeadedAccountSettingRoute =
  authHeadedAccountSettingRouteImport.update({
    id: "/setting",
    path: "/setting",
    getParentRoute: () => authHeadedAccountRouteRoute,
  } as any)
const authHeadedAccountBrandingRoute =
  authHeadedAccountBrandingRouteImport.update({
    id: "/branding",
    path: "/branding",
    getParentRoute: () => authHeadedAccountRouteRoute,
  } as any)
const authheadlessMfdHandleRoute = authheadlessMfdHandleRouteImport.update({
  id: "/(headless)/mfd/$handle",
  path: "/mfd/$handle",
  getParentRoute: () => authRoute,
} as any)
const authheadlessdistributorSetPasswordRoute =
  authheadlessdistributorSetPasswordRouteImport.update({
    id: "/(headless)/(distributor)/set-password",
    path: "/set-password",
    getParentRoute: () => authRoute,
  } as any)
const authheadlessdistributorResetPasswordRoute =
  authheadlessdistributorResetPasswordRouteImport.update({
    id: "/(headless)/(distributor)/reset-password",
    path: "/reset-password",
    getParentRoute: () => authRoute,
  } as any)
const authHeadedInsightsLayoutIndexRoute =
  authHeadedInsightsLayoutIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => authHeadedInsightsLayoutRoute,
  } as any)
const authHeadedFundsLayoutIndexRoute =
  authHeadedFundsLayoutIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => authHeadedFundsLayoutRoute,
  } as any)
const authHeadedClientsLayoutIndexRoute =
  authHeadedClientsLayoutIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => authHeadedClientsLayoutRoute,
  } as any)
const authHeadedClientsIdIndexRoute =
  authHeadedClientsIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => authHeadedClientsIdRoute,
  } as any)
const authHeadedResourcesLayoutWebinarsRoute =
  authHeadedResourcesLayoutWebinarsRouteImport.update({
    id: "/webinars",
    path: "/webinars",
    getParentRoute: () => authHeadedResourcesLayoutRoute,
  } as any)
const authHeadedResourcesLayoutMarketingRoute =
  authHeadedResourcesLayoutMarketingRouteImport.update({
    id: "/marketing",
    path: "/marketing",
    getParentRoute: () => authHeadedResourcesLayoutRoute,
  } as any)
const authHeadedResourcesLayoutKnowledgeRoute =
  authHeadedResourcesLayoutKnowledgeRouteImport.update({
    id: "/knowledge",
    path: "/knowledge",
    getParentRoute: () => authHeadedResourcesLayoutRoute,
  } as any)
const authHeadedResourcesLayoutFeaturedRoute =
  authHeadedResourcesLayoutFeaturedRouteImport.update({
    id: "/featured",
    path: "/featured",
    getParentRoute: () => authHeadedResourcesLayoutRoute,
  } as any)
const authHeadedReportsLayoutChangeOfBrokerRoute =
  authHeadedReportsLayoutChangeOfBrokerRouteImport.update({
    id: "/change-of-broker",
    path: "/change-of-broker",
    getParentRoute: () => authHeadedReportsLayoutRoute,
  } as any)
const authHeadedReportsLayoutBrokerageRoute =
  authHeadedReportsLayoutBrokerageRouteImport.update({
    id: "/brokerage",
    path: "/brokerage",
    getParentRoute: () => authHeadedReportsLayoutRoute,
  } as any)
const authHeadedInsightsLayoutSipRoute =
  authHeadedInsightsLayoutSipRouteImport.update({
    id: "/sip",
    path: "/sip",
    getParentRoute: () => authHeadedInsightsLayoutRoute,
  } as any)
const authHeadedInsightsLayoutClientsRoute =
  authHeadedInsightsLayoutClientsRouteImport.update({
    id: "/clients",
    path: "/clients",
    getParentRoute: () => authHeadedInsightsLayoutRoute,
  } as any)
const authHeadedInsightsLayoutAumRoute =
  authHeadedInsightsLayoutAumRouteImport.update({
    id: "/aum",
    path: "/aum",
    getParentRoute: () => authHeadedInsightsLayoutRoute,
  } as any)
const authHeadedFundsBasketBasket_idRoute =
  authHeadedFundsBasketBasket_idRouteImport.update({
    id: "/basket/$basket_id",
    path: "/basket/$basket_id",
    getParentRoute: () => authHeadedFundsRoute,
  } as any)
const authHeadedFundsLayoutNfoRoute =
  authHeadedFundsLayoutNfoRouteImport.update({
    id: "/nfo",
    path: "/nfo",
    getParentRoute: () => authHeadedFundsLayoutRoute,
  } as any)
const authHeadedFundsLayoutCompareRoute =
  authHeadedFundsLayoutCompareRouteImport.update({
    id: "/compare",
    path: "/compare",
    getParentRoute: () => authHeadedFundsLayoutRoute,
  } as any)
const authHeadedFundsLayoutBasketRoute =
  authHeadedFundsLayoutBasketRouteImport.update({
    id: "/basket",
    path: "/basket",
    getParentRoute: () => authHeadedFundsLayoutRoute,
  } as any)
const authHeadedClientsFamiliesIdRoute =
  authHeadedClientsFamiliesIdRouteImport.update({
    id: "/families/$id",
    path: "/families/$id",
    getParentRoute: () => authHeadedClientsRoute,
  } as any)
const authHeadedClientsLayoutFamiliesRoute =
  authHeadedClientsLayoutFamiliesRouteImport.update({
    id: "/families",
    path: "/families",
    getParentRoute: () => authHeadedClientsLayoutRoute,
  } as any)
const authHeadedClientsIdReviewRoute =
  authHeadedClientsIdReviewRouteImport.update({
    id: "/review",
    path: "/review",
    getParentRoute: () => authHeadedClientsIdRoute,
  } as any)
const authHeadedClientsIdPortfolioRoute =
  authHeadedClientsIdPortfolioRouteImport.update({
    id: "/portfolio",
    path: "/portfolio",
    getParentRoute: () => authHeadedClientsIdRoute,
  } as any)
const authHeadedClientsIdPlanningRoute =
  authHeadedClientsIdPlanningRouteImport.update({
    id: "/planning",
    path: "/planning",
    getParentRoute: () => authHeadedClientsIdRoute,
  } as any)
const authHeadedClientsIdAccountRoute =
  authHeadedClientsIdAccountRouteImport.update({
    id: "/account",
    path: "/account",
    getParentRoute: () => authHeadedClientsIdRoute,
  } as any)
const authheadlessReportsFundsCompareRoute =
  authheadlessReportsFundsCompareRouteImport.update({
    id: "/funds/compare",
    path: "/funds/compare",
    getParentRoute: () => authheadlessReportsRouteRoute,
  } as any)
const authheadlessMfdDeclarationHandleRoute =
  authheadlessMfdDeclarationHandleRouteImport.update({
    id: "/(headless)/mfd/declaration/$handle",
    path: "/mfd/declaration/$handle",
    getParentRoute: () => authRoute,
  } as any)
const authHeadedFundsBasketBasket_idIndexRoute =
  authHeadedFundsBasketBasket_idIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => authHeadedFundsBasketBasket_idRoute,
  } as any)
const authHeadedFundsBasketBasket_idLinkedSipRoute =
  authHeadedFundsBasketBasket_idLinkedSipRouteImport.update({
    id: "/linked-sip",
    path: "/linked-sip",
    getParentRoute: () => authHeadedFundsBasketBasket_idRoute,
  } as any)
const authHeadedClientsIdReviewReviewIdRoute =
  authHeadedClientsIdReviewReviewIdRouteImport.update({
    id: "/$id_/review/$reviewId",
    path: "/$id/review/$reviewId",
    getParentRoute: () => authHeadedClientsRoute,
  } as any)
const authheadlessReportsFamiliesIdPortfolioRoute =
  authheadlessReportsFamiliesIdPortfolioRouteImport.update({
    id: "/families/$id/portfolio",
    path: "/families/$id/portfolio",
    getParentRoute: () => authheadlessReportsRouteRoute,
  } as any)
const authheadlessReportsClientsIdPortfolioRoute =
  authheadlessReportsClientsIdPortfolioRouteImport.update({
    id: "/clients/$id/portfolio",
    path: "/clients/$id/portfolio",
    getParentRoute: () => authheadlessReportsRouteRoute,
  } as any)
const authheadlessReportsClientsIdOrderHistoryRoute =
  authheadlessReportsClientsIdOrderHistoryRouteImport.update({
    id: "/clients/$id/order-history",
    path: "/clients/$id/order-history",
    getParentRoute: () => authheadlessReportsRouteRoute,
  } as any)
const authheadlessReportsClientsIdCobRoute =
  authheadlessReportsClientsIdCobRouteImport.update({
    id: "/clients/$id/cob",
    path: "/clients/$id/cob",
    getParentRoute: () => authheadlessReportsRouteRoute,
  } as any)
const authheadlessReportsClientsIdCapitalGainsRoute =
  authheadlessReportsClientsIdCapitalGainsRouteImport.update({
    id: "/clients/$id/capital-gains",
    path: "/clients/$id/capital-gains",
    getParentRoute: () => authheadlessReportsRouteRoute,
  } as any)
const authheadlessReportsClientsIdProposalProposalIdRoute =
  authheadlessReportsClientsIdProposalProposalIdRouteImport.update({
    id: "/clients/$id/proposal/$proposalId",
    path: "/clients/$id/proposal/$proposalId",
    getParentRoute: () => authheadlessReportsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof authIndexRoute
  "/invite": typeof authlessInviteRoute
  "/reports": typeof authHeadedReportsLayoutRouteWithChildren
  "/account": typeof authHeadedAccountRouteRouteWithChildren
  "/welcome": typeof authheadlessWelcomeRoute
  "/home": typeof authHeadedHomeRoute
  "/login/distributor": typeof authlessLoginDistributorRoute
  "/signup/distributor": typeof authlessSignupDistributorRoute
  "/login": typeof authlessLoginIndexRoute
  "/signup": typeof authlessSignupIndexRoute
  "/reset-password": typeof authheadlessdistributorResetPasswordRoute
  "/set-password": typeof authheadlessdistributorSetPasswordRoute
  "/mfd/$handle": typeof authheadlessMfdHandleRoute
  "/account/branding": typeof authHeadedAccountBrandingRoute
  "/account/setting": typeof authHeadedAccountSettingRoute
  "/account/team-members": typeof authHeadedAccountTeamMembersRoute
  "/clients/$id": typeof authHeadedClientsIdRouteWithChildren
  "/clients": typeof authHeadedClientsLayoutRouteWithChildren
  "/funds/$fund_id": typeof authHeadedFundsFund_idRoute
  "/funds": typeof authHeadedFundsLayoutRouteWithChildren
  "/insights": typeof authHeadedInsightsLayoutRouteWithChildren
  "/resources": typeof authHeadedResourcesLayoutRouteWithChildren
  "/reports/": typeof authHeadedReportsIndexRoute
  "/resources/": typeof authHeadedResourcesIndexRoute
  "/mfd/declaration/$handle": typeof authheadlessMfdDeclarationHandleRoute
  "/reports/funds/compare": typeof authheadlessReportsFundsCompareRoute
  "/clients/$id/account": typeof authHeadedClientsIdAccountRoute
  "/clients/$id/planning": typeof authHeadedClientsIdPlanningRoute
  "/clients/$id/portfolio": typeof authHeadedClientsIdPortfolioRoute
  "/clients/$id/review": typeof authHeadedClientsIdReviewRoute
  "/clients/families": typeof authHeadedClientsLayoutFamiliesRoute
  "/clients/families/$id": typeof authHeadedClientsFamiliesIdRoute
  "/funds/basket": typeof authHeadedFundsLayoutBasketRoute
  "/funds/compare": typeof authHeadedFundsLayoutCompareRoute
  "/funds/nfo": typeof authHeadedFundsLayoutNfoRoute
  "/funds/basket/$basket_id": typeof authHeadedFundsBasketBasket_idRouteWithChildren
  "/insights/aum": typeof authHeadedInsightsLayoutAumRoute
  "/insights/clients": typeof authHeadedInsightsLayoutClientsRoute
  "/insights/sip": typeof authHeadedInsightsLayoutSipRoute
  "/reports/brokerage": typeof authHeadedReportsLayoutBrokerageRoute
  "/reports/change-of-broker": typeof authHeadedReportsLayoutChangeOfBrokerRoute
  "/resources/featured": typeof authHeadedResourcesLayoutFeaturedRoute
  "/resources/knowledge": typeof authHeadedResourcesLayoutKnowledgeRoute
  "/resources/marketing": typeof authHeadedResourcesLayoutMarketingRoute
  "/resources/webinars": typeof authHeadedResourcesLayoutWebinarsRoute
  "/clients/$id/": typeof authHeadedClientsIdIndexRoute
  "/clients/": typeof authHeadedClientsLayoutIndexRoute
  "/funds/": typeof authHeadedFundsLayoutIndexRoute
  "/insights/": typeof authHeadedInsightsLayoutIndexRoute
  "/reports/clients/$id/capital-gains": typeof authheadlessReportsClientsIdCapitalGainsRoute
  "/reports/clients/$id/cob": typeof authheadlessReportsClientsIdCobRoute
  "/reports/clients/$id/order-history": typeof authheadlessReportsClientsIdOrderHistoryRoute
  "/reports/clients/$id/portfolio": typeof authheadlessReportsClientsIdPortfolioRoute
  "/reports/families/$id/portfolio": typeof authheadlessReportsFamiliesIdPortfolioRoute
  "/clients/$id/review/$reviewId": typeof authHeadedClientsIdReviewReviewIdRoute
  "/funds/basket/$basket_id/linked-sip": typeof authHeadedFundsBasketBasket_idLinkedSipRoute
  "/funds/basket/$basket_id/": typeof authHeadedFundsBasketBasket_idIndexRoute
  "/reports/clients/$id/proposal/$proposalId": typeof authheadlessReportsClientsIdProposalProposalIdRoute
}
export interface FileRoutesByTo {
  "/": typeof authIndexRoute
  "/invite": typeof authlessInviteRoute
  "/reports": typeof authHeadedReportsIndexRoute
  "/account": typeof authHeadedAccountRouteRouteWithChildren
  "/welcome": typeof authheadlessWelcomeRoute
  "/home": typeof authHeadedHomeRoute
  "/login/distributor": typeof authlessLoginDistributorRoute
  "/signup/distributor": typeof authlessSignupDistributorRoute
  "/login": typeof authlessLoginIndexRoute
  "/signup": typeof authlessSignupIndexRoute
  "/reset-password": typeof authheadlessdistributorResetPasswordRoute
  "/set-password": typeof authheadlessdistributorSetPasswordRoute
  "/mfd/$handle": typeof authheadlessMfdHandleRoute
  "/account/branding": typeof authHeadedAccountBrandingRoute
  "/account/setting": typeof authHeadedAccountSettingRoute
  "/account/team-members": typeof authHeadedAccountTeamMembersRoute
  "/clients": typeof authHeadedClientsLayoutIndexRoute
  "/funds/$fund_id": typeof authHeadedFundsFund_idRoute
  "/funds": typeof authHeadedFundsLayoutIndexRoute
  "/insights": typeof authHeadedInsightsLayoutIndexRoute
  "/resources": typeof authHeadedResourcesIndexRoute
  "/mfd/declaration/$handle": typeof authheadlessMfdDeclarationHandleRoute
  "/reports/funds/compare": typeof authheadlessReportsFundsCompareRoute
  "/clients/$id/account": typeof authHeadedClientsIdAccountRoute
  "/clients/$id/planning": typeof authHeadedClientsIdPlanningRoute
  "/clients/$id/portfolio": typeof authHeadedClientsIdPortfolioRoute
  "/clients/$id/review": typeof authHeadedClientsIdReviewRoute
  "/clients/families": typeof authHeadedClientsLayoutFamiliesRoute
  "/clients/families/$id": typeof authHeadedClientsFamiliesIdRoute
  "/funds/basket": typeof authHeadedFundsLayoutBasketRoute
  "/funds/compare": typeof authHeadedFundsLayoutCompareRoute
  "/funds/nfo": typeof authHeadedFundsLayoutNfoRoute
  "/insights/aum": typeof authHeadedInsightsLayoutAumRoute
  "/insights/clients": typeof authHeadedInsightsLayoutClientsRoute
  "/insights/sip": typeof authHeadedInsightsLayoutSipRoute
  "/reports/brokerage": typeof authHeadedReportsLayoutBrokerageRoute
  "/reports/change-of-broker": typeof authHeadedReportsLayoutChangeOfBrokerRoute
  "/resources/featured": typeof authHeadedResourcesLayoutFeaturedRoute
  "/resources/knowledge": typeof authHeadedResourcesLayoutKnowledgeRoute
  "/resources/marketing": typeof authHeadedResourcesLayoutMarketingRoute
  "/resources/webinars": typeof authHeadedResourcesLayoutWebinarsRoute
  "/clients/$id": typeof authHeadedClientsIdIndexRoute
  "/reports/clients/$id/capital-gains": typeof authheadlessReportsClientsIdCapitalGainsRoute
  "/reports/clients/$id/cob": typeof authheadlessReportsClientsIdCobRoute
  "/reports/clients/$id/order-history": typeof authheadlessReportsClientsIdOrderHistoryRoute
  "/reports/clients/$id/portfolio": typeof authheadlessReportsClientsIdPortfolioRoute
  "/reports/families/$id/portfolio": typeof authheadlessReportsFamiliesIdPortfolioRoute
  "/clients/$id/review/$reviewId": typeof authHeadedClientsIdReviewReviewIdRoute
  "/funds/basket/$basket_id/linked-sip": typeof authHeadedFundsBasketBasket_idLinkedSipRoute
  "/funds/basket/$basket_id": typeof authHeadedFundsBasketBasket_idIndexRoute
  "/reports/clients/$id/proposal/$proposalId": typeof authheadlessReportsClientsIdProposalProposalIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/(auth)": typeof authRouteWithChildren
  "/(auth)/_headed": typeof authHeadedRouteRouteWithChildren
  "/(authless)/invite": typeof authlessInviteRoute
  "/(auth)/": typeof authIndexRoute
  "/(auth)/(headless)/reports": typeof authheadlessReportsRouteRouteWithChildren
  "/(auth)/_headed/account": typeof authHeadedAccountRouteRouteWithChildren
  "/(auth)/(headless)/welcome": typeof authheadlessWelcomeRoute
  "/(auth)/_headed/home": typeof authHeadedHomeRoute
  "/(authless)/login/distributor": typeof authlessLoginDistributorRoute
  "/(authless)/signup/distributor": typeof authlessSignupDistributorRoute
  "/(authless)/login/": typeof authlessLoginIndexRoute
  "/(authless)/signup/": typeof authlessSignupIndexRoute
  "/(auth)/(headless)/(distributor)/reset-password": typeof authheadlessdistributorResetPasswordRoute
  "/(auth)/(headless)/(distributor)/set-password": typeof authheadlessdistributorSetPasswordRoute
  "/(auth)/(headless)/mfd/$handle": typeof authheadlessMfdHandleRoute
  "/(auth)/_headed/account/branding": typeof authHeadedAccountBrandingRoute
  "/(auth)/_headed/account/setting": typeof authHeadedAccountSettingRoute
  "/(auth)/_headed/account/team-members": typeof authHeadedAccountTeamMembersRoute
  "/(auth)/_headed/clients/$id": typeof authHeadedClientsIdRouteWithChildren
  "/(auth)/_headed/clients": typeof authHeadedClientsRouteWithChildren
  "/(auth)/_headed/clients/_layout": typeof authHeadedClientsLayoutRouteWithChildren
  "/(auth)/_headed/funds/$fund_id": typeof authHeadedFundsFund_idRoute
  "/(auth)/_headed/funds": typeof authHeadedFundsRouteWithChildren
  "/(auth)/_headed/funds/_layout": typeof authHeadedFundsLayoutRouteWithChildren
  "/(auth)/_headed/insights": typeof authHeadedInsightsRouteWithChildren
  "/(auth)/_headed/insights/_layout": typeof authHeadedInsightsLayoutRouteWithChildren
  "/(auth)/_headed/reports": typeof authHeadedReportsRouteWithChildren
  "/(auth)/_headed/reports/_layout": typeof authHeadedReportsLayoutRouteWithChildren
  "/(auth)/_headed/resources": typeof authHeadedResourcesRouteWithChildren
  "/(auth)/_headed/resources/_layout": typeof authHeadedResourcesLayoutRouteWithChildren
  "/(auth)/_headed/reports/": typeof authHeadedReportsIndexRoute
  "/(auth)/_headed/resources/": typeof authHeadedResourcesIndexRoute
  "/(auth)/(headless)/mfd/declaration/$handle": typeof authheadlessMfdDeclarationHandleRoute
  "/(auth)/(headless)/reports/funds/compare": typeof authheadlessReportsFundsCompareRoute
  "/(auth)/_headed/clients/$id/account": typeof authHeadedClientsIdAccountRoute
  "/(auth)/_headed/clients/$id/planning": typeof authHeadedClientsIdPlanningRoute
  "/(auth)/_headed/clients/$id/portfolio": typeof authHeadedClientsIdPortfolioRoute
  "/(auth)/_headed/clients/$id/review": typeof authHeadedClientsIdReviewRoute
  "/(auth)/_headed/clients/_layout/families": typeof authHeadedClientsLayoutFamiliesRoute
  "/(auth)/_headed/clients/families/$id": typeof authHeadedClientsFamiliesIdRoute
  "/(auth)/_headed/funds/_layout/basket": typeof authHeadedFundsLayoutBasketRoute
  "/(auth)/_headed/funds/_layout/compare": typeof authHeadedFundsLayoutCompareRoute
  "/(auth)/_headed/funds/_layout/nfo": typeof authHeadedFundsLayoutNfoRoute
  "/(auth)/_headed/funds/basket/$basket_id": typeof authHeadedFundsBasketBasket_idRouteWithChildren
  "/(auth)/_headed/insights/_layout/aum": typeof authHeadedInsightsLayoutAumRoute
  "/(auth)/_headed/insights/_layout/clients": typeof authHeadedInsightsLayoutClientsRoute
  "/(auth)/_headed/insights/_layout/sip": typeof authHeadedInsightsLayoutSipRoute
  "/(auth)/_headed/reports/_layout/brokerage": typeof authHeadedReportsLayoutBrokerageRoute
  "/(auth)/_headed/reports/_layout/change-of-broker": typeof authHeadedReportsLayoutChangeOfBrokerRoute
  "/(auth)/_headed/resources/_layout/featured": typeof authHeadedResourcesLayoutFeaturedRoute
  "/(auth)/_headed/resources/_layout/knowledge": typeof authHeadedResourcesLayoutKnowledgeRoute
  "/(auth)/_headed/resources/_layout/marketing": typeof authHeadedResourcesLayoutMarketingRoute
  "/(auth)/_headed/resources/_layout/webinars": typeof authHeadedResourcesLayoutWebinarsRoute
  "/(auth)/_headed/clients/$id/": typeof authHeadedClientsIdIndexRoute
  "/(auth)/_headed/clients/_layout/": typeof authHeadedClientsLayoutIndexRoute
  "/(auth)/_headed/funds/_layout/": typeof authHeadedFundsLayoutIndexRoute
  "/(auth)/_headed/insights/_layout/": typeof authHeadedInsightsLayoutIndexRoute
  "/(auth)/(headless)/reports/clients/$id/capital-gains": typeof authheadlessReportsClientsIdCapitalGainsRoute
  "/(auth)/(headless)/reports/clients/$id/cob": typeof authheadlessReportsClientsIdCobRoute
  "/(auth)/(headless)/reports/clients/$id/order-history": typeof authheadlessReportsClientsIdOrderHistoryRoute
  "/(auth)/(headless)/reports/clients/$id/portfolio": typeof authheadlessReportsClientsIdPortfolioRoute
  "/(auth)/(headless)/reports/families/$id/portfolio": typeof authheadlessReportsFamiliesIdPortfolioRoute
  "/(auth)/_headed/clients/$id_/review/$reviewId": typeof authHeadedClientsIdReviewReviewIdRoute
  "/(auth)/_headed/funds/basket/$basket_id/linked-sip": typeof authHeadedFundsBasketBasket_idLinkedSipRoute
  "/(auth)/_headed/funds/basket/$basket_id/": typeof authHeadedFundsBasketBasket_idIndexRoute
  "/(auth)/(headless)/reports/clients/$id/proposal/$proposalId": typeof authheadlessReportsClientsIdProposalProposalIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/invite"
    | "/reports"
    | "/account"
    | "/welcome"
    | "/home"
    | "/login/distributor"
    | "/signup/distributor"
    | "/login"
    | "/signup"
    | "/reset-password"
    | "/set-password"
    | "/mfd/$handle"
    | "/account/branding"
    | "/account/setting"
    | "/account/team-members"
    | "/clients/$id"
    | "/clients"
    | "/funds/$fund_id"
    | "/funds"
    | "/insights"
    | "/resources"
    | "/reports/"
    | "/resources/"
    | "/mfd/declaration/$handle"
    | "/reports/funds/compare"
    | "/clients/$id/account"
    | "/clients/$id/planning"
    | "/clients/$id/portfolio"
    | "/clients/$id/review"
    | "/clients/families"
    | "/clients/families/$id"
    | "/funds/basket"
    | "/funds/compare"
    | "/funds/nfo"
    | "/funds/basket/$basket_id"
    | "/insights/aum"
    | "/insights/clients"
    | "/insights/sip"
    | "/reports/brokerage"
    | "/reports/change-of-broker"
    | "/resources/featured"
    | "/resources/knowledge"
    | "/resources/marketing"
    | "/resources/webinars"
    | "/clients/$id/"
    | "/clients/"
    | "/funds/"
    | "/insights/"
    | "/reports/clients/$id/capital-gains"
    | "/reports/clients/$id/cob"
    | "/reports/clients/$id/order-history"
    | "/reports/clients/$id/portfolio"
    | "/reports/families/$id/portfolio"
    | "/clients/$id/review/$reviewId"
    | "/funds/basket/$basket_id/linked-sip"
    | "/funds/basket/$basket_id/"
    | "/reports/clients/$id/proposal/$proposalId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/invite"
    | "/reports"
    | "/account"
    | "/welcome"
    | "/home"
    | "/login/distributor"
    | "/signup/distributor"
    | "/login"
    | "/signup"
    | "/reset-password"
    | "/set-password"
    | "/mfd/$handle"
    | "/account/branding"
    | "/account/setting"
    | "/account/team-members"
    | "/clients"
    | "/funds/$fund_id"
    | "/funds"
    | "/insights"
    | "/resources"
    | "/mfd/declaration/$handle"
    | "/reports/funds/compare"
    | "/clients/$id/account"
    | "/clients/$id/planning"
    | "/clients/$id/portfolio"
    | "/clients/$id/review"
    | "/clients/families"
    | "/clients/families/$id"
    | "/funds/basket"
    | "/funds/compare"
    | "/funds/nfo"
    | "/insights/aum"
    | "/insights/clients"
    | "/insights/sip"
    | "/reports/brokerage"
    | "/reports/change-of-broker"
    | "/resources/featured"
    | "/resources/knowledge"
    | "/resources/marketing"
    | "/resources/webinars"
    | "/clients/$id"
    | "/reports/clients/$id/capital-gains"
    | "/reports/clients/$id/cob"
    | "/reports/clients/$id/order-history"
    | "/reports/clients/$id/portfolio"
    | "/reports/families/$id/portfolio"
    | "/clients/$id/review/$reviewId"
    | "/funds/basket/$basket_id/linked-sip"
    | "/funds/basket/$basket_id"
    | "/reports/clients/$id/proposal/$proposalId"
  id:
    | "__root__"
    | "/(auth)"
    | "/(auth)/_headed"
    | "/(authless)/invite"
    | "/(auth)/"
    | "/(auth)/(headless)/reports"
    | "/(auth)/_headed/account"
    | "/(auth)/(headless)/welcome"
    | "/(auth)/_headed/home"
    | "/(authless)/login/distributor"
    | "/(authless)/signup/distributor"
    | "/(authless)/login/"
    | "/(authless)/signup/"
    | "/(auth)/(headless)/(distributor)/reset-password"
    | "/(auth)/(headless)/(distributor)/set-password"
    | "/(auth)/(headless)/mfd/$handle"
    | "/(auth)/_headed/account/branding"
    | "/(auth)/_headed/account/setting"
    | "/(auth)/_headed/account/team-members"
    | "/(auth)/_headed/clients/$id"
    | "/(auth)/_headed/clients"
    | "/(auth)/_headed/clients/_layout"
    | "/(auth)/_headed/funds/$fund_id"
    | "/(auth)/_headed/funds"
    | "/(auth)/_headed/funds/_layout"
    | "/(auth)/_headed/insights"
    | "/(auth)/_headed/insights/_layout"
    | "/(auth)/_headed/reports"
    | "/(auth)/_headed/reports/_layout"
    | "/(auth)/_headed/resources"
    | "/(auth)/_headed/resources/_layout"
    | "/(auth)/_headed/reports/"
    | "/(auth)/_headed/resources/"
    | "/(auth)/(headless)/mfd/declaration/$handle"
    | "/(auth)/(headless)/reports/funds/compare"
    | "/(auth)/_headed/clients/$id/account"
    | "/(auth)/_headed/clients/$id/planning"
    | "/(auth)/_headed/clients/$id/portfolio"
    | "/(auth)/_headed/clients/$id/review"
    | "/(auth)/_headed/clients/_layout/families"
    | "/(auth)/_headed/clients/families/$id"
    | "/(auth)/_headed/funds/_layout/basket"
    | "/(auth)/_headed/funds/_layout/compare"
    | "/(auth)/_headed/funds/_layout/nfo"
    | "/(auth)/_headed/funds/basket/$basket_id"
    | "/(auth)/_headed/insights/_layout/aum"
    | "/(auth)/_headed/insights/_layout/clients"
    | "/(auth)/_headed/insights/_layout/sip"
    | "/(auth)/_headed/reports/_layout/brokerage"
    | "/(auth)/_headed/reports/_layout/change-of-broker"
    | "/(auth)/_headed/resources/_layout/featured"
    | "/(auth)/_headed/resources/_layout/knowledge"
    | "/(auth)/_headed/resources/_layout/marketing"
    | "/(auth)/_headed/resources/_layout/webinars"
    | "/(auth)/_headed/clients/$id/"
    | "/(auth)/_headed/clients/_layout/"
    | "/(auth)/_headed/funds/_layout/"
    | "/(auth)/_headed/insights/_layout/"
    | "/(auth)/(headless)/reports/clients/$id/capital-gains"
    | "/(auth)/(headless)/reports/clients/$id/cob"
    | "/(auth)/(headless)/reports/clients/$id/order-history"
    | "/(auth)/(headless)/reports/clients/$id/portfolio"
    | "/(auth)/(headless)/reports/families/$id/portfolio"
    | "/(auth)/_headed/clients/$id_/review/$reviewId"
    | "/(auth)/_headed/funds/basket/$basket_id/linked-sip"
    | "/(auth)/_headed/funds/basket/$basket_id/"
    | "/(auth)/(headless)/reports/clients/$id/proposal/$proposalId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRoute: typeof authRouteWithChildren
  authlessInviteRoute: typeof authlessInviteRoute
  authlessLoginDistributorRoute: typeof authlessLoginDistributorRoute
  authlessSignupDistributorRoute: typeof authlessSignupDistributorRoute
  authlessLoginIndexRoute: typeof authlessLoginIndexRoute
  authlessSignupIndexRoute: typeof authlessSignupIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/(auth)": {
      id: "/(auth)"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof authRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(auth)/": {
      id: "/(auth)/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof authIndexRouteImport
      parentRoute: typeof authRoute
    }
    "/(authless)/invite": {
      id: "/(authless)/invite"
      path: "/invite"
      fullPath: "/invite"
      preLoaderRoute: typeof authlessInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(auth)/_headed": {
      id: "/(auth)/_headed"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof authHeadedRouteRouteImport
      parentRoute: typeof authRoute
    }
    "/(auth)/_headed/resources": {
      id: "/(auth)/_headed/resources"
      path: "/resources"
      fullPath: "/resources"
      preLoaderRoute: typeof authHeadedResourcesRouteImport
      parentRoute: typeof authHeadedRouteRoute
    }
    "/(auth)/_headed/reports": {
      id: "/(auth)/_headed/reports"
      path: "/reports"
      fullPath: "/reports"
      preLoaderRoute: typeof authHeadedReportsRouteImport
      parentRoute: typeof authHeadedRouteRoute
    }
    "/(auth)/_headed/insights": {
      id: "/(auth)/_headed/insights"
      path: "/insights"
      fullPath: "/insights"
      preLoaderRoute: typeof authHeadedInsightsRouteImport
      parentRoute: typeof authHeadedRouteRoute
    }
    "/(auth)/_headed/funds": {
      id: "/(auth)/_headed/funds"
      path: "/funds"
      fullPath: "/funds"
      preLoaderRoute: typeof authHeadedFundsRouteImport
      parentRoute: typeof authHeadedRouteRoute
    }
    "/(auth)/_headed/clients": {
      id: "/(auth)/_headed/clients"
      path: "/clients"
      fullPath: "/clients"
      preLoaderRoute: typeof authHeadedClientsRouteImport
      parentRoute: typeof authHeadedRouteRoute
    }
    "/(authless)/signup/": {
      id: "/(authless)/signup/"
      path: "/signup"
      fullPath: "/signup"
      preLoaderRoute: typeof authlessSignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(authless)/login/": {
      id: "/(authless)/login/"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof authlessLoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(authless)/signup/distributor": {
      id: "/(authless)/signup/distributor"
      path: "/signup/distributor"
      fullPath: "/signup/distributor"
      preLoaderRoute: typeof authlessSignupDistributorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(authless)/login/distributor": {
      id: "/(authless)/login/distributor"
      path: "/login/distributor"
      fullPath: "/login/distributor"
      preLoaderRoute: typeof authlessLoginDistributorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(auth)/_headed/home": {
      id: "/(auth)/_headed/home"
      path: "/home"
      fullPath: "/home"
      preLoaderRoute: typeof authHeadedHomeRouteImport
      parentRoute: typeof authHeadedRouteRoute
    }
    "/(auth)/(headless)/welcome": {
      id: "/(auth)/(headless)/welcome"
      path: "/welcome"
      fullPath: "/welcome"
      preLoaderRoute: typeof authheadlessWelcomeRouteImport
      parentRoute: typeof authRoute
    }
    "/(auth)/_headed/account": {
      id: "/(auth)/_headed/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof authHeadedAccountRouteRouteImport
      parentRoute: typeof authHeadedRouteRoute
    }
    "/(auth)/(headless)/reports": {
      id: "/(auth)/(headless)/reports"
      path: "/reports"
      fullPath: "/reports"
      preLoaderRoute: typeof authheadlessReportsRouteRouteImport
      parentRoute: typeof authRoute
    }
    "/(auth)/_headed/resources/": {
      id: "/(auth)/_headed/resources/"
      path: "/"
      fullPath: "/resources/"
      preLoaderRoute: typeof authHeadedResourcesIndexRouteImport
      parentRoute: typeof authHeadedResourcesRoute
    }
    "/(auth)/_headed/reports/": {
      id: "/(auth)/_headed/reports/"
      path: "/"
      fullPath: "/reports/"
      preLoaderRoute: typeof authHeadedReportsIndexRouteImport
      parentRoute: typeof authHeadedReportsRoute
    }
    "/(auth)/_headed/resources/_layout": {
      id: "/(auth)/_headed/resources/_layout"
      path: "/resources"
      fullPath: "/resources"
      preLoaderRoute: typeof authHeadedResourcesLayoutRouteImport
      parentRoute: typeof authHeadedResourcesRoute
    }
    "/(auth)/_headed/reports/_layout": {
      id: "/(auth)/_headed/reports/_layout"
      path: "/reports"
      fullPath: "/reports"
      preLoaderRoute: typeof authHeadedReportsLayoutRouteImport
      parentRoute: typeof authHeadedReportsRoute
    }
    "/(auth)/_headed/insights/_layout": {
      id: "/(auth)/_headed/insights/_layout"
      path: "/insights"
      fullPath: "/insights"
      preLoaderRoute: typeof authHeadedInsightsLayoutRouteImport
      parentRoute: typeof authHeadedInsightsRoute
    }
    "/(auth)/_headed/funds/_layout": {
      id: "/(auth)/_headed/funds/_layout"
      path: "/funds"
      fullPath: "/funds"
      preLoaderRoute: typeof authHeadedFundsLayoutRouteImport
      parentRoute: typeof authHeadedFundsRoute
    }
    "/(auth)/_headed/funds/$fund_id": {
      id: "/(auth)/_headed/funds/$fund_id"
      path: "/funds/$fund_id"
      fullPath: "/funds/$fund_id"
      preLoaderRoute: typeof authHeadedFundsFund_idRouteImport
      parentRoute: typeof authHeadedRouteRoute
    }
    "/(auth)/_headed/clients/_layout": {
      id: "/(auth)/_headed/clients/_layout"
      path: "/clients"
      fullPath: "/clients"
      preLoaderRoute: typeof authHeadedClientsLayoutRouteImport
      parentRoute: typeof authHeadedClientsRoute
    }
    "/(auth)/_headed/clients/$id": {
      id: "/(auth)/_headed/clients/$id"
      path: "/clients/$id"
      fullPath: "/clients/$id"
      preLoaderRoute: typeof authHeadedClientsIdRouteImport
      parentRoute: typeof authHeadedRouteRoute
    }
    "/(auth)/_headed/account/team-members": {
      id: "/(auth)/_headed/account/team-members"
      path: "/team-members"
      fullPath: "/account/team-members"
      preLoaderRoute: typeof authHeadedAccountTeamMembersRouteImport
      parentRoute: typeof authHeadedAccountRouteRoute
    }
    "/(auth)/_headed/account/setting": {
      id: "/(auth)/_headed/account/setting"
      path: "/setting"
      fullPath: "/account/setting"
      preLoaderRoute: typeof authHeadedAccountSettingRouteImport
      parentRoute: typeof authHeadedAccountRouteRoute
    }
    "/(auth)/_headed/account/branding": {
      id: "/(auth)/_headed/account/branding"
      path: "/branding"
      fullPath: "/account/branding"
      preLoaderRoute: typeof authHeadedAccountBrandingRouteImport
      parentRoute: typeof authHeadedAccountRouteRoute
    }
    "/(auth)/(headless)/mfd/$handle": {
      id: "/(auth)/(headless)/mfd/$handle"
      path: "/mfd/$handle"
      fullPath: "/mfd/$handle"
      preLoaderRoute: typeof authheadlessMfdHandleRouteImport
      parentRoute: typeof authRoute
    }
    "/(auth)/(headless)/(distributor)/set-password": {
      id: "/(auth)/(headless)/(distributor)/set-password"
      path: "/set-password"
      fullPath: "/set-password"
      preLoaderRoute: typeof authheadlessdistributorSetPasswordRouteImport
      parentRoute: typeof authRoute
    }
    "/(auth)/(headless)/(distributor)/reset-password": {
      id: "/(auth)/(headless)/(distributor)/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof authheadlessdistributorResetPasswordRouteImport
      parentRoute: typeof authRoute
    }
    "/(auth)/_headed/insights/_layout/": {
      id: "/(auth)/_headed/insights/_layout/"
      path: "/"
      fullPath: "/insights/"
      preLoaderRoute: typeof authHeadedInsightsLayoutIndexRouteImport
      parentRoute: typeof authHeadedInsightsLayoutRoute
    }
    "/(auth)/_headed/funds/_layout/": {
      id: "/(auth)/_headed/funds/_layout/"
      path: "/"
      fullPath: "/funds/"
      preLoaderRoute: typeof authHeadedFundsLayoutIndexRouteImport
      parentRoute: typeof authHeadedFundsLayoutRoute
    }
    "/(auth)/_headed/clients/_layout/": {
      id: "/(auth)/_headed/clients/_layout/"
      path: "/"
      fullPath: "/clients/"
      preLoaderRoute: typeof authHeadedClientsLayoutIndexRouteImport
      parentRoute: typeof authHeadedClientsLayoutRoute
    }
    "/(auth)/_headed/clients/$id/": {
      id: "/(auth)/_headed/clients/$id/"
      path: "/"
      fullPath: "/clients/$id/"
      preLoaderRoute: typeof authHeadedClientsIdIndexRouteImport
      parentRoute: typeof authHeadedClientsIdRoute
    }
    "/(auth)/_headed/resources/_layout/webinars": {
      id: "/(auth)/_headed/resources/_layout/webinars"
      path: "/webinars"
      fullPath: "/resources/webinars"
      preLoaderRoute: typeof authHeadedResourcesLayoutWebinarsRouteImport
      parentRoute: typeof authHeadedResourcesLayoutRoute
    }
    "/(auth)/_headed/resources/_layout/marketing": {
      id: "/(auth)/_headed/resources/_layout/marketing"
      path: "/marketing"
      fullPath: "/resources/marketing"
      preLoaderRoute: typeof authHeadedResourcesLayoutMarketingRouteImport
      parentRoute: typeof authHeadedResourcesLayoutRoute
    }
    "/(auth)/_headed/resources/_layout/knowledge": {
      id: "/(auth)/_headed/resources/_layout/knowledge"
      path: "/knowledge"
      fullPath: "/resources/knowledge"
      preLoaderRoute: typeof authHeadedResourcesLayoutKnowledgeRouteImport
      parentRoute: typeof authHeadedResourcesLayoutRoute
    }
    "/(auth)/_headed/resources/_layout/featured": {
      id: "/(auth)/_headed/resources/_layout/featured"
      path: "/featured"
      fullPath: "/resources/featured"
      preLoaderRoute: typeof authHeadedResourcesLayoutFeaturedRouteImport
      parentRoute: typeof authHeadedResourcesLayoutRoute
    }
    "/(auth)/_headed/reports/_layout/change-of-broker": {
      id: "/(auth)/_headed/reports/_layout/change-of-broker"
      path: "/change-of-broker"
      fullPath: "/reports/change-of-broker"
      preLoaderRoute: typeof authHeadedReportsLayoutChangeOfBrokerRouteImport
      parentRoute: typeof authHeadedReportsLayoutRoute
    }
    "/(auth)/_headed/reports/_layout/brokerage": {
      id: "/(auth)/_headed/reports/_layout/brokerage"
      path: "/brokerage"
      fullPath: "/reports/brokerage"
      preLoaderRoute: typeof authHeadedReportsLayoutBrokerageRouteImport
      parentRoute: typeof authHeadedReportsLayoutRoute
    }
    "/(auth)/_headed/insights/_layout/sip": {
      id: "/(auth)/_headed/insights/_layout/sip"
      path: "/sip"
      fullPath: "/insights/sip"
      preLoaderRoute: typeof authHeadedInsightsLayoutSipRouteImport
      parentRoute: typeof authHeadedInsightsLayoutRoute
    }
    "/(auth)/_headed/insights/_layout/clients": {
      id: "/(auth)/_headed/insights/_layout/clients"
      path: "/clients"
      fullPath: "/insights/clients"
      preLoaderRoute: typeof authHeadedInsightsLayoutClientsRouteImport
      parentRoute: typeof authHeadedInsightsLayoutRoute
    }
    "/(auth)/_headed/insights/_layout/aum": {
      id: "/(auth)/_headed/insights/_layout/aum"
      path: "/aum"
      fullPath: "/insights/aum"
      preLoaderRoute: typeof authHeadedInsightsLayoutAumRouteImport
      parentRoute: typeof authHeadedInsightsLayoutRoute
    }
    "/(auth)/_headed/funds/basket/$basket_id": {
      id: "/(auth)/_headed/funds/basket/$basket_id"
      path: "/basket/$basket_id"
      fullPath: "/funds/basket/$basket_id"
      preLoaderRoute: typeof authHeadedFundsBasketBasket_idRouteImport
      parentRoute: typeof authHeadedFundsRoute
    }
    "/(auth)/_headed/funds/_layout/nfo": {
      id: "/(auth)/_headed/funds/_layout/nfo"
      path: "/nfo"
      fullPath: "/funds/nfo"
      preLoaderRoute: typeof authHeadedFundsLayoutNfoRouteImport
      parentRoute: typeof authHeadedFundsLayoutRoute
    }
    "/(auth)/_headed/funds/_layout/compare": {
      id: "/(auth)/_headed/funds/_layout/compare"
      path: "/compare"
      fullPath: "/funds/compare"
      preLoaderRoute: typeof authHeadedFundsLayoutCompareRouteImport
      parentRoute: typeof authHeadedFundsLayoutRoute
    }
    "/(auth)/_headed/funds/_layout/basket": {
      id: "/(auth)/_headed/funds/_layout/basket"
      path: "/basket"
      fullPath: "/funds/basket"
      preLoaderRoute: typeof authHeadedFundsLayoutBasketRouteImport
      parentRoute: typeof authHeadedFundsLayoutRoute
    }
    "/(auth)/_headed/clients/families/$id": {
      id: "/(auth)/_headed/clients/families/$id"
      path: "/families/$id"
      fullPath: "/clients/families/$id"
      preLoaderRoute: typeof authHeadedClientsFamiliesIdRouteImport
      parentRoute: typeof authHeadedClientsRoute
    }
    "/(auth)/_headed/clients/_layout/families": {
      id: "/(auth)/_headed/clients/_layout/families"
      path: "/families"
      fullPath: "/clients/families"
      preLoaderRoute: typeof authHeadedClientsLayoutFamiliesRouteImport
      parentRoute: typeof authHeadedClientsLayoutRoute
    }
    "/(auth)/_headed/clients/$id/review": {
      id: "/(auth)/_headed/clients/$id/review"
      path: "/review"
      fullPath: "/clients/$id/review"
      preLoaderRoute: typeof authHeadedClientsIdReviewRouteImport
      parentRoute: typeof authHeadedClientsIdRoute
    }
    "/(auth)/_headed/clients/$id/portfolio": {
      id: "/(auth)/_headed/clients/$id/portfolio"
      path: "/portfolio"
      fullPath: "/clients/$id/portfolio"
      preLoaderRoute: typeof authHeadedClientsIdPortfolioRouteImport
      parentRoute: typeof authHeadedClientsIdRoute
    }
    "/(auth)/_headed/clients/$id/planning": {
      id: "/(auth)/_headed/clients/$id/planning"
      path: "/planning"
      fullPath: "/clients/$id/planning"
      preLoaderRoute: typeof authHeadedClientsIdPlanningRouteImport
      parentRoute: typeof authHeadedClientsIdRoute
    }
    "/(auth)/_headed/clients/$id/account": {
      id: "/(auth)/_headed/clients/$id/account"
      path: "/account"
      fullPath: "/clients/$id/account"
      preLoaderRoute: typeof authHeadedClientsIdAccountRouteImport
      parentRoute: typeof authHeadedClientsIdRoute
    }
    "/(auth)/(headless)/reports/funds/compare": {
      id: "/(auth)/(headless)/reports/funds/compare"
      path: "/funds/compare"
      fullPath: "/reports/funds/compare"
      preLoaderRoute: typeof authheadlessReportsFundsCompareRouteImport
      parentRoute: typeof authheadlessReportsRouteRoute
    }
    "/(auth)/(headless)/mfd/declaration/$handle": {
      id: "/(auth)/(headless)/mfd/declaration/$handle"
      path: "/mfd/declaration/$handle"
      fullPath: "/mfd/declaration/$handle"
      preLoaderRoute: typeof authheadlessMfdDeclarationHandleRouteImport
      parentRoute: typeof authRoute
    }
    "/(auth)/_headed/funds/basket/$basket_id/": {
      id: "/(auth)/_headed/funds/basket/$basket_id/"
      path: "/"
      fullPath: "/funds/basket/$basket_id/"
      preLoaderRoute: typeof authHeadedFundsBasketBasket_idIndexRouteImport
      parentRoute: typeof authHeadedFundsBasketBasket_idRoute
    }
    "/(auth)/_headed/funds/basket/$basket_id/linked-sip": {
      id: "/(auth)/_headed/funds/basket/$basket_id/linked-sip"
      path: "/linked-sip"
      fullPath: "/funds/basket/$basket_id/linked-sip"
      preLoaderRoute: typeof authHeadedFundsBasketBasket_idLinkedSipRouteImport
      parentRoute: typeof authHeadedFundsBasketBasket_idRoute
    }
    "/(auth)/_headed/clients/$id_/review/$reviewId": {
      id: "/(auth)/_headed/clients/$id_/review/$reviewId"
      path: "/$id/review/$reviewId"
      fullPath: "/clients/$id/review/$reviewId"
      preLoaderRoute: typeof authHeadedClientsIdReviewReviewIdRouteImport
      parentRoute: typeof authHeadedClientsRoute
    }
    "/(auth)/(headless)/reports/families/$id/portfolio": {
      id: "/(auth)/(headless)/reports/families/$id/portfolio"
      path: "/families/$id/portfolio"
      fullPath: "/reports/families/$id/portfolio"
      preLoaderRoute: typeof authheadlessReportsFamiliesIdPortfolioRouteImport
      parentRoute: typeof authheadlessReportsRouteRoute
    }
    "/(auth)/(headless)/reports/clients/$id/portfolio": {
      id: "/(auth)/(headless)/reports/clients/$id/portfolio"
      path: "/clients/$id/portfolio"
      fullPath: "/reports/clients/$id/portfolio"
      preLoaderRoute: typeof authheadlessReportsClientsIdPortfolioRouteImport
      parentRoute: typeof authheadlessReportsRouteRoute
    }
    "/(auth)/(headless)/reports/clients/$id/order-history": {
      id: "/(auth)/(headless)/reports/clients/$id/order-history"
      path: "/clients/$id/order-history"
      fullPath: "/reports/clients/$id/order-history"
      preLoaderRoute: typeof authheadlessReportsClientsIdOrderHistoryRouteImport
      parentRoute: typeof authheadlessReportsRouteRoute
    }
    "/(auth)/(headless)/reports/clients/$id/cob": {
      id: "/(auth)/(headless)/reports/clients/$id/cob"
      path: "/clients/$id/cob"
      fullPath: "/reports/clients/$id/cob"
      preLoaderRoute: typeof authheadlessReportsClientsIdCobRouteImport
      parentRoute: typeof authheadlessReportsRouteRoute
    }
    "/(auth)/(headless)/reports/clients/$id/capital-gains": {
      id: "/(auth)/(headless)/reports/clients/$id/capital-gains"
      path: "/clients/$id/capital-gains"
      fullPath: "/reports/clients/$id/capital-gains"
      preLoaderRoute: typeof authheadlessReportsClientsIdCapitalGainsRouteImport
      parentRoute: typeof authheadlessReportsRouteRoute
    }
    "/(auth)/(headless)/reports/clients/$id/proposal/$proposalId": {
      id: "/(auth)/(headless)/reports/clients/$id/proposal/$proposalId"
      path: "/clients/$id/proposal/$proposalId"
      fullPath: "/reports/clients/$id/proposal/$proposalId"
      preLoaderRoute: typeof authheadlessReportsClientsIdProposalProposalIdRouteImport
      parentRoute: typeof authheadlessReportsRouteRoute
    }
  }
}

interface authHeadedAccountRouteRouteChildren {
  authHeadedAccountBrandingRoute: typeof authHeadedAccountBrandingRoute
  authHeadedAccountSettingRoute: typeof authHeadedAccountSettingRoute
  authHeadedAccountTeamMembersRoute: typeof authHeadedAccountTeamMembersRoute
}

const authHeadedAccountRouteRouteChildren: authHeadedAccountRouteRouteChildren =
  {
    authHeadedAccountBrandingRoute: authHeadedAccountBrandingRoute,
    authHeadedAccountSettingRoute: authHeadedAccountSettingRoute,
    authHeadedAccountTeamMembersRoute: authHeadedAccountTeamMembersRoute,
  }

const authHeadedAccountRouteRouteWithChildren =
  authHeadedAccountRouteRoute._addFileChildren(
    authHeadedAccountRouteRouteChildren,
  )

interface authHeadedClientsIdRouteChildren {
  authHeadedClientsIdAccountRoute: typeof authHeadedClientsIdAccountRoute
  authHeadedClientsIdPlanningRoute: typeof authHeadedClientsIdPlanningRoute
  authHeadedClientsIdPortfolioRoute: typeof authHeadedClientsIdPortfolioRoute
  authHeadedClientsIdReviewRoute: typeof authHeadedClientsIdReviewRoute
  authHeadedClientsIdIndexRoute: typeof authHeadedClientsIdIndexRoute
}

const authHeadedClientsIdRouteChildren: authHeadedClientsIdRouteChildren = {
  authHeadedClientsIdAccountRoute: authHeadedClientsIdAccountRoute,
  authHeadedClientsIdPlanningRoute: authHeadedClientsIdPlanningRoute,
  authHeadedClientsIdPortfolioRoute: authHeadedClientsIdPortfolioRoute,
  authHeadedClientsIdReviewRoute: authHeadedClientsIdReviewRoute,
  authHeadedClientsIdIndexRoute: authHeadedClientsIdIndexRoute,
}

const authHeadedClientsIdRouteWithChildren =
  authHeadedClientsIdRoute._addFileChildren(authHeadedClientsIdRouteChildren)

interface authHeadedClientsLayoutRouteChildren {
  authHeadedClientsLayoutFamiliesRoute: typeof authHeadedClientsLayoutFamiliesRoute
  authHeadedClientsLayoutIndexRoute: typeof authHeadedClientsLayoutIndexRoute
}

const authHeadedClientsLayoutRouteChildren: authHeadedClientsLayoutRouteChildren =
  {
    authHeadedClientsLayoutFamiliesRoute: authHeadedClientsLayoutFamiliesRoute,
    authHeadedClientsLayoutIndexRoute: authHeadedClientsLayoutIndexRoute,
  }

const authHeadedClientsLayoutRouteWithChildren =
  authHeadedClientsLayoutRoute._addFileChildren(
    authHeadedClientsLayoutRouteChildren,
  )

interface authHeadedClientsRouteChildren {
  authHeadedClientsLayoutRoute: typeof authHeadedClientsLayoutRouteWithChildren
  authHeadedClientsFamiliesIdRoute: typeof authHeadedClientsFamiliesIdRoute
  authHeadedClientsIdReviewReviewIdRoute: typeof authHeadedClientsIdReviewReviewIdRoute
}

const authHeadedClientsRouteChildren: authHeadedClientsRouteChildren = {
  authHeadedClientsLayoutRoute: authHeadedClientsLayoutRouteWithChildren,
  authHeadedClientsFamiliesIdRoute: authHeadedClientsFamiliesIdRoute,
  authHeadedClientsIdReviewReviewIdRoute:
    authHeadedClientsIdReviewReviewIdRoute,
}

const authHeadedClientsRouteWithChildren =
  authHeadedClientsRoute._addFileChildren(authHeadedClientsRouteChildren)

interface authHeadedFundsLayoutRouteChildren {
  authHeadedFundsLayoutBasketRoute: typeof authHeadedFundsLayoutBasketRoute
  authHeadedFundsLayoutCompareRoute: typeof authHeadedFundsLayoutCompareRoute
  authHeadedFundsLayoutNfoRoute: typeof authHeadedFundsLayoutNfoRoute
  authHeadedFundsLayoutIndexRoute: typeof authHeadedFundsLayoutIndexRoute
}

const authHeadedFundsLayoutRouteChildren: authHeadedFundsLayoutRouteChildren = {
  authHeadedFundsLayoutBasketRoute: authHeadedFundsLayoutBasketRoute,
  authHeadedFundsLayoutCompareRoute: authHeadedFundsLayoutCompareRoute,
  authHeadedFundsLayoutNfoRoute: authHeadedFundsLayoutNfoRoute,
  authHeadedFundsLayoutIndexRoute: authHeadedFundsLayoutIndexRoute,
}

const authHeadedFundsLayoutRouteWithChildren =
  authHeadedFundsLayoutRoute._addFileChildren(
    authHeadedFundsLayoutRouteChildren,
  )

interface authHeadedFundsBasketBasket_idRouteChildren {
  authHeadedFundsBasketBasket_idLinkedSipRoute: typeof authHeadedFundsBasketBasket_idLinkedSipRoute
  authHeadedFundsBasketBasket_idIndexRoute: typeof authHeadedFundsBasketBasket_idIndexRoute
}

const authHeadedFundsBasketBasket_idRouteChildren: authHeadedFundsBasketBasket_idRouteChildren =
  {
    authHeadedFundsBasketBasket_idLinkedSipRoute:
      authHeadedFundsBasketBasket_idLinkedSipRoute,
    authHeadedFundsBasketBasket_idIndexRoute:
      authHeadedFundsBasketBasket_idIndexRoute,
  }

const authHeadedFundsBasketBasket_idRouteWithChildren =
  authHeadedFundsBasketBasket_idRoute._addFileChildren(
    authHeadedFundsBasketBasket_idRouteChildren,
  )

interface authHeadedFundsRouteChildren {
  authHeadedFundsLayoutRoute: typeof authHeadedFundsLayoutRouteWithChildren
  authHeadedFundsBasketBasket_idRoute: typeof authHeadedFundsBasketBasket_idRouteWithChildren
}

const authHeadedFundsRouteChildren: authHeadedFundsRouteChildren = {
  authHeadedFundsLayoutRoute: authHeadedFundsLayoutRouteWithChildren,
  authHeadedFundsBasketBasket_idRoute:
    authHeadedFundsBasketBasket_idRouteWithChildren,
}

const authHeadedFundsRouteWithChildren = authHeadedFundsRoute._addFileChildren(
  authHeadedFundsRouteChildren,
)

interface authHeadedInsightsLayoutRouteChildren {
  authHeadedInsightsLayoutAumRoute: typeof authHeadedInsightsLayoutAumRoute
  authHeadedInsightsLayoutClientsRoute: typeof authHeadedInsightsLayoutClientsRoute
  authHeadedInsightsLayoutSipRoute: typeof authHeadedInsightsLayoutSipRoute
  authHeadedInsightsLayoutIndexRoute: typeof authHeadedInsightsLayoutIndexRoute
}

const authHeadedInsightsLayoutRouteChildren: authHeadedInsightsLayoutRouteChildren =
  {
    authHeadedInsightsLayoutAumRoute: authHeadedInsightsLayoutAumRoute,
    authHeadedInsightsLayoutClientsRoute: authHeadedInsightsLayoutClientsRoute,
    authHeadedInsightsLayoutSipRoute: authHeadedInsightsLayoutSipRoute,
    authHeadedInsightsLayoutIndexRoute: authHeadedInsightsLayoutIndexRoute,
  }

const authHeadedInsightsLayoutRouteWithChildren =
  authHeadedInsightsLayoutRoute._addFileChildren(
    authHeadedInsightsLayoutRouteChildren,
  )

interface authHeadedInsightsRouteChildren {
  authHeadedInsightsLayoutRoute: typeof authHeadedInsightsLayoutRouteWithChildren
}

const authHeadedInsightsRouteChildren: authHeadedInsightsRouteChildren = {
  authHeadedInsightsLayoutRoute: authHeadedInsightsLayoutRouteWithChildren,
}

const authHeadedInsightsRouteWithChildren =
  authHeadedInsightsRoute._addFileChildren(authHeadedInsightsRouteChildren)

interface authHeadedReportsLayoutRouteChildren {
  authHeadedReportsLayoutBrokerageRoute: typeof authHeadedReportsLayoutBrokerageRoute
  authHeadedReportsLayoutChangeOfBrokerRoute: typeof authHeadedReportsLayoutChangeOfBrokerRoute
}

const authHeadedReportsLayoutRouteChildren: authHeadedReportsLayoutRouteChildren =
  {
    authHeadedReportsLayoutBrokerageRoute:
      authHeadedReportsLayoutBrokerageRoute,
    authHeadedReportsLayoutChangeOfBrokerRoute:
      authHeadedReportsLayoutChangeOfBrokerRoute,
  }

const authHeadedReportsLayoutRouteWithChildren =
  authHeadedReportsLayoutRoute._addFileChildren(
    authHeadedReportsLayoutRouteChildren,
  )

interface authHeadedReportsRouteChildren {
  authHeadedReportsLayoutRoute: typeof authHeadedReportsLayoutRouteWithChildren
  authHeadedReportsIndexRoute: typeof authHeadedReportsIndexRoute
}

const authHeadedReportsRouteChildren: authHeadedReportsRouteChildren = {
  authHeadedReportsLayoutRoute: authHeadedReportsLayoutRouteWithChildren,
  authHeadedReportsIndexRoute: authHeadedReportsIndexRoute,
}

const authHeadedReportsRouteWithChildren =
  authHeadedReportsRoute._addFileChildren(authHeadedReportsRouteChildren)

interface authHeadedResourcesLayoutRouteChildren {
  authHeadedResourcesLayoutFeaturedRoute: typeof authHeadedResourcesLayoutFeaturedRoute
  authHeadedResourcesLayoutKnowledgeRoute: typeof authHeadedResourcesLayoutKnowledgeRoute
  authHeadedResourcesLayoutMarketingRoute: typeof authHeadedResourcesLayoutMarketingRoute
  authHeadedResourcesLayoutWebinarsRoute: typeof authHeadedResourcesLayoutWebinarsRoute
}

const authHeadedResourcesLayoutRouteChildren: authHeadedResourcesLayoutRouteChildren =
  {
    authHeadedResourcesLayoutFeaturedRoute:
      authHeadedResourcesLayoutFeaturedRoute,
    authHeadedResourcesLayoutKnowledgeRoute:
      authHeadedResourcesLayoutKnowledgeRoute,
    authHeadedResourcesLayoutMarketingRoute:
      authHeadedResourcesLayoutMarketingRoute,
    authHeadedResourcesLayoutWebinarsRoute:
      authHeadedResourcesLayoutWebinarsRoute,
  }

const authHeadedResourcesLayoutRouteWithChildren =
  authHeadedResourcesLayoutRoute._addFileChildren(
    authHeadedResourcesLayoutRouteChildren,
  )

interface authHeadedResourcesRouteChildren {
  authHeadedResourcesLayoutRoute: typeof authHeadedResourcesLayoutRouteWithChildren
  authHeadedResourcesIndexRoute: typeof authHeadedResourcesIndexRoute
}

const authHeadedResourcesRouteChildren: authHeadedResourcesRouteChildren = {
  authHeadedResourcesLayoutRoute: authHeadedResourcesLayoutRouteWithChildren,
  authHeadedResourcesIndexRoute: authHeadedResourcesIndexRoute,
}

const authHeadedResourcesRouteWithChildren =
  authHeadedResourcesRoute._addFileChildren(authHeadedResourcesRouteChildren)

interface authHeadedRouteRouteChildren {
  authHeadedAccountRouteRoute: typeof authHeadedAccountRouteRouteWithChildren
  authHeadedHomeRoute: typeof authHeadedHomeRoute
  authHeadedClientsIdRoute: typeof authHeadedClientsIdRouteWithChildren
  authHeadedClientsRoute: typeof authHeadedClientsRouteWithChildren
  authHeadedFundsFund_idRoute: typeof authHeadedFundsFund_idRoute
  authHeadedFundsRoute: typeof authHeadedFundsRouteWithChildren
  authHeadedInsightsRoute: typeof authHeadedInsightsRouteWithChildren
  authHeadedReportsRoute: typeof authHeadedReportsRouteWithChildren
  authHeadedResourcesRoute: typeof authHeadedResourcesRouteWithChildren
}

const authHeadedRouteRouteChildren: authHeadedRouteRouteChildren = {
  authHeadedAccountRouteRoute: authHeadedAccountRouteRouteWithChildren,
  authHeadedHomeRoute: authHeadedHomeRoute,
  authHeadedClientsIdRoute: authHeadedClientsIdRouteWithChildren,
  authHeadedClientsRoute: authHeadedClientsRouteWithChildren,
  authHeadedFundsFund_idRoute: authHeadedFundsFund_idRoute,
  authHeadedFundsRoute: authHeadedFundsRouteWithChildren,
  authHeadedInsightsRoute: authHeadedInsightsRouteWithChildren,
  authHeadedReportsRoute: authHeadedReportsRouteWithChildren,
  authHeadedResourcesRoute: authHeadedResourcesRouteWithChildren,
}

const authHeadedRouteRouteWithChildren = authHeadedRouteRoute._addFileChildren(
  authHeadedRouteRouteChildren,
)

interface authheadlessReportsRouteRouteChildren {
  authheadlessReportsFundsCompareRoute: typeof authheadlessReportsFundsCompareRoute
  authheadlessReportsClientsIdCapitalGainsRoute: typeof authheadlessReportsClientsIdCapitalGainsRoute
  authheadlessReportsClientsIdCobRoute: typeof authheadlessReportsClientsIdCobRoute
  authheadlessReportsClientsIdOrderHistoryRoute: typeof authheadlessReportsClientsIdOrderHistoryRoute
  authheadlessReportsClientsIdPortfolioRoute: typeof authheadlessReportsClientsIdPortfolioRoute
  authheadlessReportsFamiliesIdPortfolioRoute: typeof authheadlessReportsFamiliesIdPortfolioRoute
  authheadlessReportsClientsIdProposalProposalIdRoute: typeof authheadlessReportsClientsIdProposalProposalIdRoute
}

const authheadlessReportsRouteRouteChildren: authheadlessReportsRouteRouteChildren =
  {
    authheadlessReportsFundsCompareRoute: authheadlessReportsFundsCompareRoute,
    authheadlessReportsClientsIdCapitalGainsRoute:
      authheadlessReportsClientsIdCapitalGainsRoute,
    authheadlessReportsClientsIdCobRoute: authheadlessReportsClientsIdCobRoute,
    authheadlessReportsClientsIdOrderHistoryRoute:
      authheadlessReportsClientsIdOrderHistoryRoute,
    authheadlessReportsClientsIdPortfolioRoute:
      authheadlessReportsClientsIdPortfolioRoute,
    authheadlessReportsFamiliesIdPortfolioRoute:
      authheadlessReportsFamiliesIdPortfolioRoute,
    authheadlessReportsClientsIdProposalProposalIdRoute:
      authheadlessReportsClientsIdProposalProposalIdRoute,
  }

const authheadlessReportsRouteRouteWithChildren =
  authheadlessReportsRouteRoute._addFileChildren(
    authheadlessReportsRouteRouteChildren,
  )

interface authRouteChildren {
  authHeadedRouteRoute: typeof authHeadedRouteRouteWithChildren
  authIndexRoute: typeof authIndexRoute
  authheadlessReportsRouteRoute: typeof authheadlessReportsRouteRouteWithChildren
  authheadlessWelcomeRoute: typeof authheadlessWelcomeRoute
  authheadlessdistributorResetPasswordRoute: typeof authheadlessdistributorResetPasswordRoute
  authheadlessdistributorSetPasswordRoute: typeof authheadlessdistributorSetPasswordRoute
  authheadlessMfdHandleRoute: typeof authheadlessMfdHandleRoute
  authheadlessMfdDeclarationHandleRoute: typeof authheadlessMfdDeclarationHandleRoute
}

const authRouteChildren: authRouteChildren = {
  authHeadedRouteRoute: authHeadedRouteRouteWithChildren,
  authIndexRoute: authIndexRoute,
  authheadlessReportsRouteRoute: authheadlessReportsRouteRouteWithChildren,
  authheadlessWelcomeRoute: authheadlessWelcomeRoute,
  authheadlessdistributorResetPasswordRoute:
    authheadlessdistributorResetPasswordRoute,
  authheadlessdistributorSetPasswordRoute:
    authheadlessdistributorSetPasswordRoute,
  authheadlessMfdHandleRoute: authheadlessMfdHandleRoute,
  authheadlessMfdDeclarationHandleRoute: authheadlessMfdDeclarationHandleRoute,
}

const authRouteWithChildren = authRoute._addFileChildren(authRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authRoute: authRouteWithChildren,
  authlessInviteRoute: authlessInviteRoute,
  authlessLoginDistributorRoute: authlessLoginDistributorRoute,
  authlessSignupDistributorRoute: authlessSignupDistributorRoute,
  authlessLoginIndexRoute: authlessLoginIndexRoute,
  authlessSignupIndexRoute: authlessSignupIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
